/** 
 *   商品收藏
 */
import { get,post } from '@/untils/js/axios.js'

// 添加&取消收藏
export const favoriteGoods = (id,params) => post(`/goods/handle-collect/${id}`, params)

// 收藏列表
export const getFavoriteGoodsList = params => get('/goods/collect-list', params)